<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="登录状态" name="1">
        <div class="verticallyCenter">
          <label class="fs14 mr16">状态</label>
          <el-radio-group v-model="loginStatus">
            <el-radio label="1" class="mr24">登录前</el-radio>
            <el-radio label="2">登录后</el-radio>
          </el-radio-group>
        </div>
        <div class="mt16">
          <div class="verticallyBetween">
<!--            <span class="verticallyCenter">下拉菜单<i class="tips-btn icon-portal-info2"></i></span>-->
            <span class="verticallyCenter">下拉菜单</span>
            <span class="add-menu icon-portal-plus" @click="handleCommand('add')"></span>
          </div>
          <div class="menu-box">
            <draggable
              element="ul"
              v-model="menuLists"
              handle=".mover"
              ghost-class="ghost"
              chosen-class="chosen"
              @start="startDrag"
              @end="endDrag"
              filter=".disabled"
            >
              <li class="menu-item verticallyCenter" v-for="(item, index) in menuLists.slice(0,menuLists.length - 1)" :key="index">
                <i class="mover icondrag icon-portal-drag" :class="dragging ? 'dragging' : ''"></i>
                <span class="text overflowHid1">{{ item.label }}</span>
                <div class="btn-box">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
                    ><span class="icon-portal-edit-1" @click.stop="handleCommand('edit', item, index)"></span
                  ></el-tooltip>
                  <el-tooltip
                    v-if="index != menuLists.length - 1"
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    :open-delay="1000"
                    ><span class="icon-portal-delete1" @click.stop="handleDel(index)"></span
                  ></el-tooltip>
                </div>
              </li>
              <div v-if="!menuLists" class="null-box">暂无内容</div>
            </draggable>
            <!-- 退出登录不能删除 -->
            <div class="menu-item verticallyCenter">
              <i class="icondrag icon-portal-drag disabled"></i>
              <span class="text overflowHid1">{{ menuLists[menuLists.length - 1].label }}</span>
              <!-- <div class="btn-box">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
                  ><span class="icon-portal-edit-1" @click.stop="handleCommand('edit', menuLists[menuLists.length - 1], menuLists.length - 1)"></span
                ></el-tooltip>
              </div> -->
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="menu-set-dialog-wrap padding12" @click.stop="closeSetStatu" v-show="showSetDialog">
      <div class="menu-set-dialog" @click.stop>
        <div class="dialog-title verticallyBetween">
          <span>下拉菜单</span>
          <span class="close el-icon el-icon-close" @click.stop="closeSetStatu"></span>
        </div>
        <div class="dialog-content">
          <el-input v-model="entryList.label" placeholder="请输入菜单名称"></el-input>
          <el-input v-model="entryList.value" class="text-inp mt8" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" resize="none" placeholder="请输入http://或https://开头的地址"></el-input>
          <el-checkbox v-model="entryList.ifNewOpenLog" class="mt8">新页面打开</el-checkbox>
        </div>
        <div class="dialog-footer">
          <el-button type="default" @click.stop="closeSetStatu">取消</el-button>
          <el-button type="primary" @click="saveMenuClick">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from "qs"
import $ from "jquery"
import draggable from "vuedraggable"
import { handleFindLayoutComponentOptions, getAllColsUidInLayoutComponent } from "utils"
export default {
  components: {
    draggable
  },
  props: {
  },
  data() {
    return {
      activeNames: ["1", "2", "3"], 
      collapseActiveNames: ["1", "2", "3"],
      dragging: false,
      showSetDialog: false,
      entryLabel: "",
      entryLink: "",
      ifNewOpenLog: false,
      colsUid: null,
      selectItem: null,
      entryList: {
        label: "",
        value: "",
        ifNewOpenLog: false
      }
    }
  },
  watch: {
  },
  mounted() {
   
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      return this.$getOptions(this.ids)
    },
    loginStatus: {
      get() {
        return this.getOptions.loginStatus || "2"
      },
      set(newVal) {
        if (newVal == "1") {
          this.$changeOptionsEV(0, "activeIndex", false, null, {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
          })
        } else if(newVal == "2") {
          this.$changeOptionsEV(1, "activeIndex", false, null, {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
          })
        }
        this.$changeOptionsEV(newVal, "loginStatus", false)
      }
    },
    dragLists() {
      // 最后一个元素不参与拖拽
      let list = this.menuLists
      return list.slice(0,list.length - 1)
    },
    menuLists: {
      get() {
        this.getSelectItem()
        let selectOptions = this.selectItem.selectOptions[0].children
        return selectOptions
      },
      set(newVal) {
        let selectOptions = this.selectItem.selectOptions
        selectOptions[0].children = newVal
        this.$changeOptionsEV(selectOptions, "selectOptions", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.colsUid,
          elementInLayoutId: this.selectItem.elementInLayoutId
        })
      }
    }
  },
  methods: {
    getSelectItem() {
      const layoutRowsArr = this.getOptions.rows[1]
      this.colsUid = getAllColsUidInLayoutComponent([layoutRowsArr])[0] //获取当前row里的所有cols的uid
      this.selectItem = handleFindLayoutComponentOptions([this.getOptions.rows[1]], this.colsUid)[1]
    },
    closeSetStatu() {
      this.showSetDialog = undefined
    },
    addMenuClick() {
      this.showSetDialog = true
    },
    startDrag(e) {
      this.dragging = true
    },
    endDrag(e) {
      this.dragging = false
    },
    handleCommand(type, item, index) {
      this.showSetDialog = true
      if (type === 'edit') {
        this.entryList.label = item.label
        this.entryList.value = item.value
        this.entryList.ifNewOpenLog = item.ifNewOpenLog
      } else {
        this.entryList.label = ""
        this.entryList.value = ""
        this.entryList.ifNewOpenLog = false
      }
      this.entryList.type = type
      this.entryList.index = index
    },
    handleDel(index) {
      this.menuLists.splice(index,1)
    },
    saveMenuClick() {
      this.showSetDialog = false
      if(!this.entryList.label && !this.entryList.value) return
      const menuItem = {
        children: [],
        label: this.entryList.label,
        value: this.entryList.value,
        ifNewOpenLog: this.entryList.ifNewOpenLog
      }
      if (this.entryList.type === "edit") {
        this.menuLists[this.entryList.index] = menuItem
      } else {
        // 添加最后一个 退出登录 不能删除
        this.menuLists.splice(this.menuLists.length - 1,0,menuItem)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mr24 {
  margin-right: 24px !important;
}
.mr4 {
  margin-right: 4px;
}
.verticallyBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-menu {
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 16px;
  border-radius: 4px;
  color: var(--themeColor);
  cursor: pointer;
}
.add-menu:hover {
  background: rgba(0, 0, 0, 0.05);
}
.menu-box {
  background: var(--cardBgColor);
  border: 1px solid var(--borderColorFour);
  border-radius: 4px;
  margin-top: 8px;
  padding: 8px;
  .menu-item {
    position: relative;
    height: 32px;
    border-radius: 4px;
    margin-top: 8px;
    &:first-child {
      margin-top: 0;
    }
    .icondrag {
      color: var(--fourthTextColor);
      margin-right: 6px;
      font-size: 16px;
      &:not(.disabled):hover {
        color: var(--themeColor);
        cursor: grab;
      }
      &.dragging {
        cursor: grabbing;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .img {
      width: 20px;
      height: 20px;
      border: 1px solid #dee0e3;
      border-radius: 4px;
      overflow: hidden;
      margin-right: 4px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: top;
      }
    }
    .text {
      width: calc(100% - 80px);
    }
    .btn-box {
      span {
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
        color: var(--subTextColor);
        cursor: pointer;
        margin-left: 4px;
        &:hover {
          background: rgba(31, 35, 41, 0.08);
        }
      }
    }
  }
}
::v-deep .chosen {
  background: #FFFFFF !important;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
::v-deep .chosen::after {
  content: "";
  height: 0px;
}
::v-deep .ghost {
  border: none !important;
  box-shadow: none !important;
}
::v-deep .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background: var(--themeColor);
}
.menu-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}
.menu-set-dialog {
  position: absolute;
  top: 50%;
  left: 8px;
  right: 8px;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  .dialog-title {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #F0F0F0;
    padding-left: 12px;
    padding-right: 8px;
    .close {
      width: 24px;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
      &:hover {
        color: var(--subTextColor);
        background: var(--inputNuberHoverThemeBgColor);
      }
    }
  }
  .dialog-content {
    padding: 12px 12px 0;
  }
  .dialog-footer {
    padding: 12px;
    text-align: right;
  }
}
::v-deep .text-inp {
  .el-textarea__inner {
    color: rgba(0, 0, 0, 0.8);
    background-color: var(--inputBackGround);
    border: none;
    padding: 6px 12px;
    &:focus {
      box-shadow: inset 0px 0px 0px 2px var(--themeColor);
    }
    &:hover {
      background: var(--inputNuberHoverThemeBgColor);
    }
    &::placeholder {
      font-size: 13px;
      line-height: 20px;
      color: var(--fourthTextColor);
    }
  }
}
.null-box {
  line-height: 32px;
  text-align: center;
  font-size: 12px;
  color: var(--thirdTextColor);
}
</style>